import { createFileRoute } from '@tanstack/react-router'

import { CollectionsScorecardScreen } from './-components/collections-scorecard-screen.tsx'

export const Route = createFileRoute('/cs-tools/collections-scorecard')({
  component: CollectionsScorecardScreen
})
